import { render, staticRenderFns } from "./ProductsWithoutDeliveryTypes.vue?vue&type=template&id=a4866ddc&scoped=true"
import script from "./ProductsWithoutDeliveryTypes.vue?vue&type=script&lang=ts"
export * from "./ProductsWithoutDeliveryTypes.vue?vue&type=script&lang=ts"
import style0 from "./ProductsWithoutDeliveryTypes.vue?vue&type=style&index=0&id=a4866ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4866ddc",
  null
  
)

export default component.exports